import React from "react";
import Hidden from "@material-ui/core/Hidden";
import {IconButton, Tooltip} from "@material-ui/core";
import {FileCopy, MoreVert} from "@material-ui/icons";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {IconEditar as Edit, IconExcluir as DeleteIcon} from "../../components/icons/MateraIcons";

export const AcoesApontamentoTable = ({props, item, dataProvider}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    return <>
        <Hidden xsDown>
            <div style={{width: 150}}>

                <Tooltip
                    title="Alterar"
                    placement={'top'}
                    enterDelay={300}>
                    <IconButton aria-label="Alterar" onClick={() => props.funcs.clickRow(item)}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
                <Tooltip
                    title="Apagar"
                    placement={'top'}
                    enterDelay={300}>
                    <IconButton aria-label="Apagar" onClick={() => props.funcs.deletePendency(item)}>
                        <DeleteIcon/>
                    </IconButton>
                </Tooltip>
                <Tooltip
                    title="Copiar Apontamento"
                    placement={'top'}
                    enterDelay={300}>
                    <IconButton aria-label="Copiar" onClick={() => dataProvider.selectPendency(item)}>
                        <FileCopy/>
                    </IconButton>
                </Tooltip>
            </div>
        </Hidden>
        <Hidden smUp>
            <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}
            >
                <MoreVert/>
            </IconButton>
            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
            >
                <MenuItem onClick={handleClose}>
                    <IconButton aria-label="Alterar" onClick={() => props.funcs.clickRow(item)}>
                        <Edit/>
                    </IconButton>
                    <IconButton aria-label="Apagar" onClick={() => props.funcs.deletePendency(item)}>
                        <DeleteIcon/>
                    </IconButton>
                    <IconButton aria-label="Copiar" onClick={() => dataProvider.selectPendency(item)}>
                        <FileCopy/>
                    </IconButton>
                </MenuItem>
            </Menu>
        </Hidden>
    </>

}
